import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
    default as Select,
    components,
} from 'react-select';
import Async from 'react-select/async';
import Creatable from 'react-select/creatable';
import AsyncCreatable from 'react-select/async-creatable';

const propTypes = {
    async: PropTypes.bool,
    creatable: PropTypes.bool,
};

const defaultProps = {
    async: false,
    creatable: false,
};

export const ComponentRenderer = components;

class AutoSelect extends Component {

    render() {
        const {
            async,
            creatable,
        } = this.props;
        let ComponentClass = Select;
        if (async && creatable) {
            ComponentClass = AsyncCreatable;
        } else if (async) {
            ComponentClass = Async;
        } else if (creatable) {
            ComponentClass = Creatable;
        }
        return (
            <ComponentClass
                className="c-form-field__autoselect"
                classNamePrefix="c-form-field__autoselect"
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...this.props}
            />
        );
    }

}

AutoSelect.propTypes = propTypes;

AutoSelect.defaultProps = defaultProps;

export default AutoSelect;
